import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";
import { returnPath } from "@/auth/return-path";
import { accountsApi } from "@/lib/accounts-api";
import { CustomerSelectPage } from "@/pages/CustomerSelectPage";
import { LoginPage } from "@/pages/LoginPage";

export function AuthFlowPage() {
  const location = useLocation();
  const { isAuthenticated, isRestoring, customers, selectedCustomer } = useAuth();

  const from = returnPath(location.state);
  const hasCustomerSession = accountsApi.hasActiveCustomerSession();

  if (isRestoring) {
    return (
      <div className="py-10 text-center text-muted-foreground">
        Загрузка...
      </div>
    );
  }

  if (
    isAuthenticated &&
    (hasCustomerSession || customers.length <= 1 || selectedCustomer)
  ) {
    return <Navigate to={from} replace />;
  }

  if (isAuthenticated && customers.length > 1 && !selectedCustomer) {
    return <CustomerSelectPage redirectTo={from} />;
  }

  return <LoginPage />;
}
